import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { PAGE } from '@ap-angular/shared/schema';

@Component({
	selector: 'ap-provider-legal',
	templateUrl: './legal.component.html',
	styleUrls: ['legal.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderLegalComponent {

	public readonly PAGE = PAGE;

	constructor() {
	}
}
